import { EventBus } from '@/event-bus';
import { productImageService } from '../_services';
import { generic_storage } from '../_utilities/generic_storage';

const extendedProductImageStore = generic_storage('productImageService');

extendedProductImageStore.state = {
  ...extendedProductImageStore.state,
  status: 'idle', // loading, idle, complete
};

extendedProductImageStore.actions = {
  ...extendedProductImageStore.actions,
  createItems({ dispatch, commit }, items) {
    const promises = [];
    commit('reset');
    commit('updateStatus', 'loading');
    commit('setIsLoading', true);
    items.forEach((item) => {
      promises.push(dispatch('createItem', item));
    });
    return Promise.all(promises).then(() => {
      setTimeout(() => {
        commit('updateStatus', 'idle');
      }, 500);
    }).then(() => {
      commit('updateStatus', 'complete');
    }).catch(() => {
      commit('updateStatus', 'idle');
      EventBus.$emit('toast-error', 'There\'s been an error while trying to update this product, please try again in a few seconds.');
    })
      .finally(() => {
        commit('setIsLoading', false);
      });
  },
  addPage({ commit }, args = null) {
    commit('setIsLoading', true);
    return productImageService.getItems(args).then((response) => {
      commit('addItemPage', response.data.results);
      commit('updateItemsCount', response.data.count);
      commit('setIsLoading', false);
      return response;
    });
  },
  createItem({ commit }, item) {
    return productImageService.postItem(item).then((r) => {
      commit('addItem', r.data);
    });
  },
  patchItem({ commit }, item) {
    commit('setIsLoading', true);
    return productImageService.patchItem(item.pk, item).then((response) => response).catch(() => {
      EventBus.$emit('toast-error', 'There\'s been an error while trying to update this product, please try again in a few seconds.');
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  setIsLoading({ commit }, status) {
    commit('setIsLoading', status);
  },
};

extendedProductImageStore.mutations = {
  ...extendedProductImageStore.mutations,
  addItem(state, item) {
    state.items.push(item);
  },
  addItemPage(state, items) {
    state.items.push(...items);
  },
  updateStatus(state, status) {
    state.status = status;
  },
};

export default extendedProductImageStore;
